<template>

    <form @submit.prevent="armazenar">

        <div class="block">
            <div class="block-title">
                <div class="block-options pull-right">
                    <a class="btn btn-effect-ripple btn-default"
                       @click="verificaSenha"
                       title="Adicionar transportador">
                        <i class="iBlockDependencias fa"
                           :class="{'fa-chevron-circle-up' : mostrarDados, 'fa-chevron-circle-down' : !mostrarDados }"></i>
                    </a>
                </div>
                <h3>Configurações gerais</h3>
            </div>

            <div class="row" v-if="mostrarDados">
                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            label="Série NFS-e"
                            conexao="numerama"
                            :selecionado="configuracao.serie_nfse"
                            :selecionado-config="{label : 'nome_completo', campo : 'id'}"
                            @input="(serie) => $set(configuracao, 'serie_nfse_id', serie.id)"
                            url-busca="api/serieNf/pesquisar"
                            :extra="{'modelo': 'RPS'}"
                            :campos-table="[{'label' : 'Série / Lote', 'campo' : 'nome_completo'}]">
                    </vc-pesquisa>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            label="Forma à vista"
                            conexao="numerama"
                            :selecionado="configuracao.forma_pagamento_vista"
                            :selecionado-config="{label : 'nome', campo : 'id'}"
                            @input="(forma) => $set(configuracao, 'forma_pagamento_vista_id ', forma.id)"
                            url-busca="api/formasPagamento/pesquisar"
                            :extra="{'tipoForma': 'VISTA'}"
                            :campos-table="[{'label' : 'Nome', 'campo' : 'nome'}]">
                    </vc-pesquisa>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            label="Forma à boleto"
                            conexao="numerama"
                            :selecionado="configuracao.forma_pagamento_boleto"
                            :selecionado-config="{label : 'nome', campo : 'id'}"
                            @input="(forma) => $set(configuracao, 'forma_pagamento_boleto_id', forma.id)"
                            url-busca="api/formasPagamento/pesquisar"
                            :extra="{'tipoForma': 'BOLETO'}"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}]">
                    </vc-pesquisa>
                </div>

                <div class="col-xs-12 col-sm-4" v-if="configuracao.forma_pagamento_boleto_id != null">
                    <vc-pesquisa
                            label="Conta bancária"
                            conexao="numerama"
                            :selecionado="configuracao.conta_bancaria"
                            @input="(conta) => $set(configuracao, 'conta_bancaria_id', conta.id)"
                            :selecionado-config="{label : 'nome_completo', campo : 'id'}"
                            url-busca="api/contasBancarias/buscar"
                            :extra="{'emiteBoleto': '1', 'paginate': true}"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome_completo'}]">
                    </vc-pesquisa>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Senha de autorização</label>
                        <input type="password" v-model="configuracao.senha" class="form-control"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <div class="form-group">
                        <label>Logo</label><br>
                        <span v-if="configuracao.caminho_logo != null" class="text-success">Logo inforamada!</span>
                        <span v-else class="text-danger">Não informado!</span>
                        <input type="file" @change="setLogo($event)">
                    </div>
                </div>

            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem padrão protocolo</label>
                    <textarea cols="30" rows="5" class="form-control"
                              v-model="configuracao.mensagem_padrao_protocolo"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem padrão resultado</label>
                    <textarea cols="30" rows="5" class="form-control"
                              v-model="configuracao.mensagem_padrao_resultado"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem padrão resultado análise de sementes</label>
                    <textarea cols="30" rows="5" class="form-control"
                              v-model="configuracao.mensagem_padrao_resultado_analise_semente"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem padrão resultado análise de tecido vegetal</label>
                    <textarea cols="30" rows="5" class="form-control"
                              v-model="configuracao.mensagem_padrao_resultado_analise_tecido_vegetal"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem padrão resultado análise de fertilizante</label>
                    <textarea cols="30" rows="5" class="form-control"
                              v-model="configuracao.mensagem_padrao_resultado_analise_fertilizante"></textarea>
                </div>
            </div>

            <!--<div class="col-xs-12 col-sm-4">-->
            <!--<div class="form-group">-->
            <!--<label>Mensagem padrão relatorio análise pendente</label>-->
            <!--<textarea cols="30" rows="5" class="form-control" v-model="configuracao.mensagem_padrao_relatorio_analise_pendente"></textarea>-->
            <!--</div>-->
            <!--</div>-->
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem impressão química</label>
                    <textarea cols="30" rows="3" class="form-control"
                              v-model="configuracao.observacao_impressao_analise_quimica"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem impressão física</label>
                    <textarea cols="30" rows="3" class="form-control"
                              v-model="configuracao.observacao_impressao_analise_fisica"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem impressão extrato saturação</label>
                    <textarea cols="30" rows="3" class="form-control"
                              v-model="configuracao.observacao_impressao_analise_extrato"></textarea>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem impressão metais pesados</label>
                    <textarea cols="30" rows="3" class="form-control"
                              v-model="configuracao.observacao_impressao_analise_metais"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem impressão semente</label>
                    <textarea cols="30" rows="3" class="form-control"
                              v-model="configuracao.observacao_impressao_analise_semente"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem impressão tecido vegetal</label>
                    <textarea cols="30" rows="3" class="form-control"
                              v-model="configuracao.observacao_impressao_analise_tecido_vegetal"></textarea>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Mensagem impressão fertilizante</label>
                    <textarea cols="30" rows="3" class="form-control"
                              v-model="configuracao.observacao_impressao_analise_fertilizante"></textarea>
                </div>
            </div>
        </div>

        <div class="block">
            <div class="block-title">
                <h3>Vincular produtos</h3>
            </div>

            <div class="row">
                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            label="Produto vinculado a análise de solo"
                            :extra="extraData"
                            :selecionado="configuracao.produto_solo"
                            @input="(produto) => configuracao.analise_produto_solo = produto.id"
                            conexao="numerama"
                            :selecionado-config="{label : 'nome', campo : 'id'}"
                            url-busca="api/produtos/pesquisa"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}]">
                    </vc-pesquisa>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            label="Produto vinculado a análise de semente"
                            :extra="extraData"
                            :selecionado="configuracao.produto_semente"
                            @input="(produto) => configuracao.analise_produto_semente = produto.id"
                            conexao="numerama"
                            :selecionado-config="{label : 'nome', campo : 'id'}"
                            url-busca="api/produtos/pesquisa"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}]">
                    </vc-pesquisa>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            label="Produto vinculado a análise de tecido vegetal"
                            :selecionado="configuracao.produto_tecido"
                            @input="(produto) => configuracao.analise_produto_tecido = produto.id"
                            :extra="extraData"
                            conexao="numerama"
                            :selecionado-config="{label : 'nome', campo : 'id'}"
                            url-busca="api/produtos/pesquisa"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}]">
                    </vc-pesquisa>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            label="Produto vinculado a análise de fertilizante"
                            :selecionado="configuracao.produto_fertilizante"
                            @input="(produto) => configuracao.analise_produto_fertilizante = produto.id"
                            :extra="extraData"
                            conexao="numerama"
                            :selecionado-config="{label : 'nome', campo : 'id'}"
                            url-busca="api/produtos/pesquisa"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}]">
                    </vc-pesquisa>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            label="Produto vinculado a análise externa"
                            :extra="extraData"
                            :selecionado="configuracao.produto_externo"
                            @input="(produto) => configuracao.analise_produto_externo = produto.id"
                            conexao="numerama"
                            :selecionado-config="{label : 'nome', campo : 'id'}"
                            url-busca="api/produtos/pesquisa"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nome'}]">
                    </vc-pesquisa>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12">
                <h4 class="title">Tabela de preços</h4>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Química (R$)</label>
                    <money v-model="configuracao.valor_quimica" class="form-control"></money>
                </div>
            </div>
            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Física (R$)</label>
                    <money v-model="configuracao.valor_fisica" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Química e fisíca (R$)</label>
                    <money v-model="configuracao.valor_quimica_fisica" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Metais pesados (R$)</label>
                    <money v-model="configuracao.valor_metais_pesados" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Extrato saturação (R$)</label>
                    <money v-model="configuracao.valor_extrato_saturacao" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Valor API (R$)</label>
                    <money v-model="configuracao.valor_analise_api" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Valor análise externa (R$)</label>
                    <money v-model="configuracao.valor_analise_externa_site" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Pacote de novos elementos (R$)</label>
                    <money v-model="configuracao.pacote_elementos_1" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Ph (calc2) (R$)</label>
                    <money v-model="configuracao.valor_ph_calc2" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Fosforo Resina (R$)</label>
                    <money v-model="configuracao.valor_fosforo_resina" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Ferro (R$)</label>
                    <money v-model="configuracao.valor_ferro" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Condutividade (R$)</label>
                    <money v-model="configuracao.valor_condutividade" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Nitrogenio Azoto (R$)</label>
                    <money v-model="configuracao.valor_nitrogenio_azoto" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Silicio (R$)</label>
                    <money v-model="configuracao.valor_silicio" class="form-control"></money>
                </div>
            </div>
        </div>

        <br>
        <div class="row">
            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Tecido vegetal (R$)</label>
                    <money v-model="configuracao.valor_tecido_vegetal" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Fertilizante (R$)</label>
                    <money v-model="configuracao.valor_fertilizante" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Germinação (R$)</label>
                    <money v-model="configuracao.valor_germinacao" class="form-control"></money>
                </div>
            </div>

            <div class="col-xs-12 col-sm-4">
                <div class="form-group">
                    <label>Vigor (R$)</label>
                    <money v-model="configuracao.valor_vigor" class="form-control"></money>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xs-12 col-md-4">
                <div class="form-group">
                    <button type="submit" class="btn btn-success">Salvar</button>&nbsp;
                    <router-link :to="{name: 'home'}" class="btn btn-danger">Cancelar</router-link>
                </div>
            </div>
        </div>
    </form>

</template>

<script>
    import VcPesquisa from '@/components/Form/Pesquisa'

    export default {
        data() {
            return {
                configuracao: {},
                extraData: {'ativo': '1', 'filtroProdServ': '1'},
                logo: null,
                mostrarDados: false
            }
        },
        components: {
            VcPesquisa
        },
        methods: {
            setLogo(event) {
                this.logo = event.target.files[0]
            },

            verificaSenha() {
                if (this.$store.state.Empresa.configuracao.senha == null) {
                    this.$set(this, 'mostrarDados', !this.mostrarDados)
                    return true
                }

                if (!this.mostrarDados) {
                    window.swal({
                        title: 'Informe a senha para ter acesso a essas informações.',
                        input: 'password',
                        showCancelButton: true,
                        confirmButtonText: 'Confirmar',
                        cancelButtonText: 'Cancelar',
                        showLoaderOnConfirm: true,
                        preConfirm: (senha) => {
                            if (senha == this.$store.state.Empresa.configuracao.senha) {
                                this.$set(this, 'mostrarDados', true)
                                return true
                            }
                            window.swal.showValidationMessage('Senha inválida.')
                            return false
                        },
                        allowOutsideClick: () => !window.swal.isLoading()
                    }).then((result) => {
                        if (result.dismiss != undefined && (result.dismiss == "cancel" || result.dismiss == "esc" || result.dismiss == "overlay")) {
                            $('#inicialAmostraSolosEtiqueta').addClass('active')
                            $('#inicialReceber').removeClass('active')
                            $('#inicialAmostraSolosEtiqueta').click()
                        }
                    })
                } else {
                    this.$set(this, 'mostrarDados', false)
                }
            },

            async armazenar() {
                this.$http.post('api/configuracoes', this.configuracao).then(async () => {
                    if (this.logo != null) {
                        let formData = new FormData();
                        formData.append("logo", this.logo);

                        await this.$http.post("api/configuracoes/logo", formData, {
                                headers: {"Content-Type": "multipart/form-data"}
                            }
                        );
                    }
                    return window.swal("Sucesso", "Configuração armazenada com sucesso!", "success");
                }).catch(error => window.swal("Atenção", "Houve um problema ao armazenar a configuração. <br><br>" + error.response.data.message))

                this.$store.dispatch('setConfiguracao')
            },
        },
        mounted() {
            this.$http.get('api/configuracoes').then((response) => {
                this.$set(this, 'configuracao', response.data.configuracao)
            })
            this.$store.dispatch('setTitle', 'Configurações')

            this.$set(this, 'mostrarDados', this.$store.state.Empresa.configuracao.senha == null)
        }
    }
</script>

<style>
    .linha-tabela {
        line-height: 5.5 !important;
    }
</style>
